import { Component, Input } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AggFunc,
  BaseComponent,
  GridService,
  SalesOrderAllocation,
  SalesOrderAllocations,
  SalesOrderLineService,
  SummaryItem,
} from 'tms-lib';
import { PurchaseOrderSalesAllocationService } from '../../../services';

@Component({
  selector: 'app-purchase-order-line-sales-order-allocations-modal',
  templateUrl: './purchase-order-line-sales-order-allocations-modal.component.html',
  styleUrl: './purchase-order-line-sales-order-allocations-modal.component.scss',
})
export class PurchaseOrderLineSalesOrderAllocationsModalComponent extends BaseComponent {
  @Input() model: SalesOrderAllocations;
  @Input() showDelete = false;

  constructor(
    private gridService: GridService,
    private purchaseOrderSalesAllocationService: PurchaseOrderSalesAllocationService,
    private salesOrderLineService: SalesOrderLineService,
  ) {
    super();
  }

  summaryItems(model: SalesOrderAllocations): SummaryItem[] {
    return [
      { label: $localize`Purchase Order Number`, value: model.salesOrderAndLineNo },
      { label: $localize`Product`, value: model.productKey },
      { label: $localize`Description`, value: model.productDescription },
      { label: $localize`Product Type`, value: model.productType },
    ];
  }

  readonly columnDefs: ColDef[] = [
    this.gridService.text('allocationType', $localize`Allocation Type`),
    this.gridService.text('orderNo', $localize`Order Number`),
    this.gridService.text('supplierKey', $localize`Supplier Key`),
    this.gridService.text('supplierName', $localize`Supplier Name`),
    this.gridService.numberFormat('allocated', $localize`Allocated`, { aggFunc: AggFunc.sum }),
    this.gridService.date('deliveryDate', $localize`Delivery Date`),
  ];

  get rowData$(): Observable<SalesOrderAllocation[]> {
    return of(this.model?.allocations ?? []);
  }

  getModel() {
    this.salesOrderLineService
      .salesOrderAllocations(this.model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model: SalesOrderAllocations) => (this.model = model));
  }

  delete(salesOrderAllocations: SalesOrderAllocation) {
    this.purchaseOrderSalesAllocationService
      .delete(salesOrderAllocations.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.getModel());
  }
}
